import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.number.constructor";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
export default {
  name: 'CoreTenantDialogDeleteTenant',
  props: {
    open: {
      type: Boolean,
      required: false,
      default: false
    },
    accountId: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: function data() {
    return {
      accountInformation: null,
      subAccountTree: null,
      digitalTwinsTree: null,
      accountInformationFetched: false,
      accountInformationError: false,
      confii: null
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled'])),
  watch: {
    open: function open() {
      if (this.open) {
        this.getAccountDetails();
      }

      this.confii = null;
    },
    accountId: function accountId() {
      this.getAccountDetails();
    }
  },
  methods: {
    getAccountDetails: function getAccountDetails() {
      var _this = this;

      this.accountInformationFetched = false;
      this.accountInformationError = false;
      this.getSubAccountsAndDigitalTwins().then(function (result) {
        _this.accountInformation = result;
        _this.subAccountTree = _this.buildSubAccountTree(result);
        _this.digitalTwinsTree = _this.buildDigitalTwinsTree(result);
        _this.accountInformationFetched = true;
      }).catch(function () {
        // getTenantById() responds on errors with wrong messages
        // not matte which request fails we only recognize it as generic for now
        // https://digimondo.atlassian.net/browse/TWIN-617
        _this.accountInformationError = true;
      });
    },
    getSubAccountsAndDigitalTwins: function () {
      var _getSubAccountsAndDigitalTwins = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var account, digitalTwins;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return ApiService.tenantGetById(this.accountId, ['descendents']).then(function (accountData) {
                  return {
                    name: accountData.name,
                    id: accountData.id,
                    parentId: accountData.parentId,
                    scopeId: accountData.scopeId,
                    children: _this2.buildListFromNestedChildren(accountData)
                  };
                });

              case 2:
                account = _context.sent;
                _context.next = 5;
                return ApiService.digitalTwinsFetch(this, null, [account.scopeId], null, ['bare']).then(function (twinData) {
                  return twinData.digitaltwins;
                });

              case 5:
                digitalTwins = _context.sent;
                return _context.abrupt("return", {
                  account: _objectSpread(_objectSpread({}, account), {}, {
                    children: undefined
                  }),
                  subAccounts: account.children,
                  digitalTwins: digitalTwins
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSubAccountsAndDigitalTwins() {
        return _getSubAccountsAndDigitalTwins.apply(this, arguments);
      }

      return getSubAccountsAndDigitalTwins;
    }(),
    buildSubAccountTree: function buildSubAccountTree(data) {
      // Accounts need the root node to be able to build the tree up to root node parentId
      var withRootNode = [data.account].concat(_toConsumableArray(data.subAccounts));
      var rootNodeParentId = data.account.parentId;
      var children = this.buildTreeFromList(withRootNode, rootNodeParentId)[0].children || [];
      var name = this.$i18n_tc('accMgmt.tenant.deleteConfimationSubAccounts', data.subAccounts.length, {
        n: data.subAccounts.length
      });
      return [{
        id: null,
        parentId: null,
        name: name,
        children: children
      }];
    },
    buildDigitalTwinsTree: function buildDigitalTwinsTree(data) {
      var children = this.buildTreeFromList(data.digitalTwins);
      var title = this.$i18n_tc('accMgmt.tenant.deleteConfimationDigitalTwins', data.digitalTwins.length, {
        n: data.digitalTwins.length
      });
      return [{
        id: null,
        parentId: null,
        title: title,
        children: children
      }];
    },
    buildListFromNestedChildren: function buildListFromNestedChildren() {
      var _this3 = this;

      var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!Array.isArray(object.children)) {
        return [];
      }

      return object.children.reduce(function (prev, cur) {
        return [].concat(_toConsumableArray(prev), [{
          id: cur.id,
          parentId: cur.parentId,
          name: cur.name
        }], _toConsumableArray(cur.children ? _this3.buildListFromNestedChildren(cur) : []));
      }, []);
    },
    buildTreeFromList: function buildTreeFromList(array) {
      var fromId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!Array.isArray(array)) {
        return [];
      }

      var data = cloneDeep(array); // create id mapping to index array

      var idMapping = data.reduce(function (prev, cur, idx) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, cur.id, idx));
      }, {});
      var root = [];
      data.forEach(function (el) {
        // get root element based on given parameters
        if (el.id === fromId && fromId !== fromId || el.parentId === fromId) {
          root.push(el);
          return;
        } // get parent element via id mapping array


        var parentEl = data[idMapping[el.parentId]]; // add to parents `children` array

        if (parentEl) {
          parentEl['children'] = [].concat(_toConsumableArray(parentEl['children'] || []), [el]); // as the original request already contains children (with just an ID), filter elements that do not have a name or title

          parentEl['children'] = parentEl['children'].filter(function (child) {
            return child.name || child.title;
          });
        }
      });

      if (root.length === 1 && !root[0].children) {
        root[0]['children'] = [];
      }

      return root || [];
    }
  }
};